import React from 'react';
import CTA from '@/components/shared/CTA';

interface LogoProps {
    id: string;
}
const Logo: React.FC<LogoProps> = ( { id = '' } )=> {
    return (
        <CTA classes={ [ 'af-logo' ] } url={ homeURL + '/' } id={ id }><span>{ 'Astraea Lesbian Foundation for Justice' }</span></CTA>
    )
}
export default Logo;